(function() {
  var Controller, jenks, merge, turfintersect,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  turfintersect = require('node_modules/turf-intersect');

  merge = require('node_modules/turf-merge');

  jenks = require('node_modules/turf-jenks');

  exports.DefineZonesController = (function(superClass) {
    extend(DefineZonesController, superClass);

    function DefineZonesController(scope, transitions, zone_type, pgis, validation, undo) {
      this.scope = scope;
      this.transitions = transitions;
      this.zone_type = zone_type;
      this.pgis = pgis;
      this.validation = validation;
      this.undo = undo;
      this._setModeListeners = bind(this._setModeListeners, this);
      this.initializeListeners = bind(this.initializeListeners, this);
      this.validateLayers = bind(this.validateLayers, this);
      this.clipAll = bind(this.clipAll, this);
      this.handleCombineDrawnZone = bind(this.handleCombineDrawnZone, this);
      this.formatData = bind(this.formatData, this);
      this.sortFeatureVsCollection = bind(this.sortFeatureVsCollection, this);
      this.tryMultiPolygonize = bind(this.tryMultiPolygonize, this);
      this.featureCollection = bind(this.featureCollection, this);
      this.findByTarget = bind(this.findByTarget, this);
      this.convertSavedZones = bind(this.convertSavedZones, this);
      this.convertGeoJSON = bind(this.convertGeoJSON, this);
      this.colorSelectedZone = bind(this.colorSelectedZone, this);
      this.resetOtherZoneColors = bind(this.resetOtherZoneColors, this);
      this.addZone = bind(this.addZone, this);
      this.finalizeZone = bind(this.finalizeZone, this);
      this.selectZone = bind(this.selectZone, this);
      this.disableTools = bind(this.disableTools, this);
      this.setDrawingOptions = bind(this.setDrawingOptions, this);
      this.handleZoneListeners = bind(this.handleZoneListeners, this);
      this.setDrawOptions = bind(this.setDrawOptions, this);
      this.deleteZone = bind(this.deleteZone, this);
      this.fillGeom = bind(this.fillGeom, this);
      this.validateRings = bind(this.validateRings, this);
      this.deleteEmptyZones = bind(this.deleteEmptyZones, this);
      this.initializeByProcessMode = bind(this.initializeByProcessMode, this);
      this.setFromBackButton = bind(this.setFromBackButton, this);
      this.noDataNeedsLoaded = bind(this.noDataNeedsLoaded, this);
      this.validate = bind(this.validate, this);
      this.cleanup = bind(this.cleanup, this);
      this.isEditing = bind(this.isEditing, this);
      this.initializeVariables = bind(this.initializeVariables, this);
      this.setBackButtonDisable = bind(this.setBackButtonDisable, this);
      this.initialize = bind(this.initialize, this);
      if (this.validation.canContinue()) {
        this.initialize();
      }
    }

    DefineZonesController.prototype.initialize = function() {
      this.initializeVariables();
      this.initializeListeners();
      return this.setBackButtonDisable();
    };

    DefineZonesController.prototype.setBackButtonDisable = function(field_data) {
      return this.validation.setBackButtonDisable(this.scope.field_data, 'zone-edit');
    };

    DefineZonesController.prototype.initializeVariables = function() {
      this.scope.validate = this.validate;
      this.scope.cleanup = this.cleanup;
      this.validation.setStepScope(this.scope);
      this.scope.field_data = this.validation.getFieldData();
      this.scope.deleteZone = this.deleteZone;
      this.scope.selectZone = this.selectZone;
      this.scope.addZone = this.addZone;
      this.scope.current_zone = this.scope.current_zone != null ? this.scope.current_zone : null;
      this.scope.mode = '';
      this.scope.loaded = {
        table: false
      };
      this.scope.disabled.next = false;
      this.opacity = 0.6;
      this.scope.zone_object = this.scope.field_data.zones[this.zone_type];
      this.ctrl = new L.Control.MfDraw({});
      this.ctrl.setFinishedStyle(this.opacity);
      this.initializeByProcessMode();
      App.map.addControl(this.ctrl);
      this.undo.setDrawControl(this.ctrl);
      if (this.zone_type === 'irrigation' && !this.isEditing()) {
        this.ctrl.getButton('draw-circle-add').trigger('click');
      } else if (!this.isEditing()) {
        this.ctrl.getButton('draw-poly-add').trigger('click');
      }
      return this.fillGeom();
    };

    DefineZonesController.prototype.isEditing = function() {
      return this.scope.field_data.process_mode === 'zone-edit';
    };

    DefineZonesController.prototype.cleanup = function() {
      delete this.scope.field_data;
      delete this.scope.current_zone;
      return this.undo.cleanup();
    };

    DefineZonesController.prototype.validate = function() {
      this.validation.setFieldData(this.scope.field_data);
      return true;
    };

    DefineZonesController.prototype.noDataNeedsLoaded = function() {
      var ref, ref1, ref2, ref3;
      return ((ref = this.scope) != null ? (ref1 = ref.zone_object) != null ? (ref2 = ref1.zones) != null ? ref2.length : void 0 : void 0 : void 0) === 0 && (((ref3 = this.scope.zone_object) != null ? ref3.loaded_zones : void 0) == null);
    };

    DefineZonesController.prototype.setFromBackButton = function() {
      var count, i, j, len, ref, results;
      this.scope.loaded.table = true;
      count = 0;
      ref = this.scope.zone_object.zones;
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        i = ref[j];
        i.settings = [];
        i.color = this.validation.zones_service.getNextColor(false, count);
        count += 1;
        results.push(this.convertGeoJSON(i.visible.toGeoJSON(), i));
      }
      return results;
    };

    DefineZonesController.prototype.initializeByProcessMode = function() {
      var ref, ref1, ref2, ref3, ref4, ref5;
      if (this.noDataNeedsLoaded()) {
        if (this.scope.field_data.visited_settings != null) {
          this.scope.loaded.table = true;
          this.setFromBackButton();
          this.selectZone(this.scope.zone_object.zones[0]);
        } else {
          this.addZone();
          this.scope.loaded.table = true;
          this.scope.polygons = this.ctrl.getAreas([], null, 1, this.pgis.units);
        }
      } else if (((ref = this.scope) != null ? (ref1 = ref.field_data) != null ? ref1.process_mode : void 0 : void 0) === 'zone-edit') {
        if (this.scope.field_data.visited_settings != null) {
          this.scope.loaded.table = true;
          this.setFromBackButton();
        } else {
          this.pgis.fieldDataGeoJsonToBoundaryLayer(this.scope.field_data, true, true);
          this.convertSavedZones();
          if (this.scope.zone_object.zones[0] == null) {
            this.addZone();
          }
          this.selectZone(this.scope.zone_object.zones[0]);
        }
      } else if ((ref2 = (ref3 = this.scope) != null ? (ref4 = ref3.field_data) != null ? ref4.process_mode : void 0 : void 0) === 'zone-add' || ref2 === 'irrigation-add') {
        if (this.scope.field_data.visited_settings != null) {
          this.scope.loaded.table = true;
          this.setFromBackButton();
        } else if ((ref5 = this.scope.zone_object.loaded_zones) != null ? ref5.length : void 0) {
          this.convertSavedZones();
          this.scope.loaded.table = true;
          this.deleteEmptyZones();
          this.selectZone(this.scope.zone_object.zones[0]);
        }
      }
      if (!this.scope.current_zone) {
        return this.selectZone(this.scope.zone_object.zones[0]);
      }
    };

    DefineZonesController.prototype.deleteEmptyZones = function() {
      var deleted, geojson, index, j, len, ref, ref1, zone;
      deleted = false;
      ref = this.scope.zone_object.zones;
      for (index = j = 0, len = ref.length; j < len; index = ++j) {
        zone = ref[index];
        if ((zone.visible != null) || (zone.geojson != null)) {
          if ((ref1 = zone.visible) != null ? ref1.toGeoJSON() : void 0) {
            geojson = zone.visible.toGeoJSON();
          } else if (zone.geojson != null) {
            geojson = zone.geoJson;
          }
          if (!(turf.area(geojson) > 0) && this.scope.zone_object.zones.length > 1) {
            this.deleteZone(zone);
            deleted = true;
            break;
          }
        } else {
          deleted = false;
          this.deleteZone(zone);
          break;
        }
      }
      if (deleted) {
        return this.deleteEmptyZones();
      }
    };

    DefineZonesController.prototype.validateRings = function(feature) {
      var index, j, len, oneOneHundrethOfAnAcreInSqMeters, ref, ring, validated_rings;
      if (feature.geometry.type !== 'MultiPolygon') {
        return feature;
      }
      validated_rings = [];
      oneOneHundrethOfAnAcreInSqMeters = 40.46;
      ref = feature.geometry.coordinates;
      for (index = j = 0, len = ref.length; j < len; index = ++j) {
        ring = ref[index];
        if (turf.area(turf.polygon(ring, {})) > oneOneHundrethOfAnAcreInSqMeters) {
          validated_rings.push(ring);
        }
      }
      feature.geometry.coordinates = validated_rings;
      return feature;
    };

    DefineZonesController.prototype.fillGeom = function() {
      var boundary, existing_geoms, j, len, len1, m, ref, ref1, total, z, zone;
      this.scope.auto = false;
      existing_geoms = [];
      ref = this.scope.zone_object.zones;
      for (j = 0, len = ref.length; j < len; j++) {
        zone = ref[j];
        existing_geoms.push(L.GeoUtil.multiPolygonize(zone.visible.toGeoJSON()));
      }
      boundary = L.GeoUtil.multiPolygonize(this.scope.field_data.boundary);
      total = existing_geoms[0];
      for (m = 0, len1 = existing_geoms.length; m < len1; m++) {
        z = existing_geoms[m];
        if (!(z !== total && z.geometry.coordinates.length)) {
          continue;
        }
        if (total.geometry.geometries != null) {
          total = this.validation.convertGeometryCollection(total);
          total.push(z);
          total = merge({
            type: 'FeatureCollection',
            features: total
          });
        } else {
          z = this.validateRings(z);
          total = merge({
            type: 'FeatureCollection',
            features: [z, total]
          });
        }
        total = this.validateRings(total);
      }
      if (total && (((ref1 = total.geometry) != null ? ref1.type : void 0) != null)) {
        this.pgis.clipAll(boundary, [total], boundary).then((function(_this) {
          return function(response) {
            var ref2, result;
            result = response.data.data;
            if ((result != null ? (ref2 = result.geometry) != null ? ref2.type : void 0 : void 0) != null) {
              result = _this.validateRings(result);
              if (turf.area(result) >= 0.1) {
                return _this.scope.fillgeom = result;
              } else {
                return _this.scope.fillgeom = null;
              }
            } else {
              _this.scope.fillgeom = null;
              return _this.deleteEmptyZones();
            }
          };
        })(this));
      } else {
        this.scope.fillgeom = null;
      }
      return this.pgis.setFieldData(this.scope.field_data);
    };

    DefineZonesController.prototype.deleteZone = function(zone) {
      var ind, ref;
      if (zone != null) {
        if ((ref = zone.visible) != null) {
          ref.clearLayers();
        }
      }
      if (this.scope.zone_object.zones.length === 1) {
        return;
      }
      if (this.scope.current_zone === zone) {
        ind = this.scope.zone_object.zones.indexOf(zone);
        this.selectZone(this.scope.zone_object.zones[Math.abs(ind - 1) % this.scope.zone_object.zones.length]);
      }
      _.remove(this.scope.zone_object.zones, zone);
      return this.fillGeom();
    };

    DefineZonesController.prototype.setDrawOptions = function(zone) {
      this.ctrl.options.draw.style = {
        'weight': 2,
        'color': zone.color,
        'fillOpacity': 0.6
      };
      return this.ctrl.options.finished.style = {
        'weight': 2,
        'color': zone.color,
        'fillOpacity': 0.6
      };
    };

    DefineZonesController.prototype.handleZoneListeners = function(zone) {
      var j, len, ref, results, z;
      ref = this.scope.zone_object.zones;
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        z = ref[j];
        if (z !== zone) {
          z.visible.off('click', this.ctrl._polySelected);
          z.visible.off('click', this.findByTarget);
          results.push(z.visible.on('click', this.findByTarget));
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    DefineZonesController.prototype.setDrawingOptions = function(zone) {
      this.ctrl.setLayer(zone != null ? zone.visible : void 0);
      this.ctrl.options.draw.style = {
        'weight': 2,
        'color': '#00ff00',
        fillColor: zone.color,
        'fillOpacity': 0.6
      };
      return this.ctrl.options.finished.style = {
        'weight': 5,
        'color': '#FFFFFF',
        fillColor: zone.color,
        'fillOpacity': 0.6,
        dashArray: [10, 8]
      };
    };

    DefineZonesController.prototype.disableTools = function() {
      var ref;
      this.ctrl.deselectAllButtons();
      return (ref = this.ctrl.current_tool) != null ? ref.disable() : void 0;
    };

    DefineZonesController.prototype.selectZone = function(zone, needs_applied) {
      var ref, ref1, select;
      if (needs_applied == null) {
        needs_applied = false;
      }
      this.disableTools();
      this.handleZoneListeners(zone);
      select = (function(_this) {
        return function(zone) {
          _this.setDrawingOptions(zone);
          _this.scope.current_zone = zone;
          if (needs_applied !== false) {
            _this.scope.$apply();
          }
          _this.colorSelectedZone(zone);
          return _this.undo.cleanup();
        };
      })(this);
      if ((ref = this.scope.current_zone) != null ? (ref1 = ref.visible) != null ? typeof ref1.toGeoJson === "function" ? ref1.toGeoJson() : void 0 : void 0 : void 0) {
        return this.finalizeZone(this.scope.current_zone.visible.toGeoJSON()).then((function(_this) {
          return function() {
            return select(zone);
          };
        })(this));
      } else {
        return select(zone);
      }
    };

    DefineZonesController.prototype.finalizeZone = function(combined) {
      var collection, field, j, len, ref, zone;
      collection = [];
      field = L.GeoUtil.multiPolygonize(this.scope.field_data.boundary);
      ref = this.scope.zone_object.zones;
      for (j = 0, len = ref.length; j < len; j++) {
        zone = ref[j];
        if (zone !== this.scope.current_zone) {
          collection.push(L.GeoUtil.multiPolygonize(zone.visible.toGeoJSON()));
        }
      }
      return this.pgis.clipAll(combined, collection, field).then((function(_this) {
        return function(response) {
          return _this.ctrl._finishDrawing(response.data.data, false, false);
        };
      })(this));
    };

    DefineZonesController.prototype.addZone = function() {
      var ref, zone;
      zone = {
        unique_id: ++this.scope.field_data.zone_unique_id,
        settings: {},
        visible: new L.FeatureGroup(),
        unclipped: new L.FeatureGroup(),
        color: this.validation.zones_service.getNextColor((ref = _.last(this.scope.zone_object.zones)) != null ? ref.color : void 0),
        area: (function(_this) {
          return function() {
            var gj;
            gj = zone.visible.toGeoJSON();
            if (App.is_metric) {
              return turf.area(gj) * 0.0001;
            } else {
              return turf.area(gj) * 0.000247105;
            }
          };
        })(this)
      };
      zone.visible.on('click', (function(_this) {
        return function(e) {
          return _this.findByTarget(e);
        };
      })(this));
      this.scope.zone_object.zones.push(zone);
      zone.visible.addTo(App.map);
      return this.selectZone(zone);
    };

    DefineZonesController.prototype.copyArea = function(a, b) {
      var k, v;
      for (k in a) {
        v = a[k];
        b[k] = v;
      }
      return b;
    };

    DefineZonesController.prototype.resetOtherZoneColors = function(z, style) {
      var geojson, j, len, ref, results, zone;
      ref = this.scope.zone_object.zones;
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        zone = ref[j];
        if (z !== zone) {
          if ((zone != null ? zone.visible : void 0) != null) {
            style.fillColor = zone.color;
            style.color = zone.color;
            geojson = zone != null ? zone.visible.toGeoJSON() : void 0;
            results.push(this.convertGeoJSON(geojson, zone, style));
          } else {
            results.push(void 0);
          }
        }
      }
      return results;
    };

    DefineZonesController.prototype.colorSelectedZone = function(zone) {
      var base, geojson, style;
      style = this.validation.zones_service.defaultZoneStyle();
      this.resetOtherZoneColors(zone, style);
      style = this.validation.zones_service.defaultZoneStyle(true, zone.color, 5, true);
      if ((zone != null ? zone.visible : void 0) != null) {
        geojson = zone != null ? typeof (base = zone.visible).toGeoJSON === "function" ? base.toGeoJSON() : void 0 : void 0;
        return this.convertGeoJSON(geojson, zone, style);
      }
    };

    DefineZonesController.prototype.convertGeoJSON = function(geojson, zone, style) {
      if (style == null) {
        style = null;
      }
      zone.visible.clearLayers();
      if (style == null) {
        style = this.validation.zones_service.defaultZoneStyle(zone.color);
      }
      return L.geoJson(geojson).eachLayer((function(_this) {
        return function(l) {
          l.setStyle(style != null ? style : {});
          zone.visible.addLayer(l);
          zone.unclipped.addLayer(l);
          _this.pgis.added_layers.push(l);
          return zone.visible.addTo(App.map);
        };
      })(this));
    };

    DefineZonesController.prototype.convertSavedZones = function() {
      var area, index, j, len, ref, style, z;
      ref = this.scope.zone_object.loaded_zones;
      for (index = j = 0, len = ref.length; j < len; index = ++j) {
        area = ref[index];
        area.unique_id = ++this.scope.field_data.zone_unique_id;
        area.settings = {};
        area.visible = new L.FeatureGroup();
        area.unclipped = new L.FeatureGroup();
        area.color = this.validation.zones_service.getNextColor(null, index);
        area.identity = area.id;
        style = this.validation.zones_service.defaultZoneStyle(area.color);
        z = this.copyArea(area, {});
        L.geoJson(z.geometry).eachLayer((function(_this) {
          return function(l) {
            l.setStyle(style != null ? style : {});
            z.visible.addLayer(l);
            z.unclipped.addLayer(l);
            _this.pgis.added_layers.push;
            return z.visible.addTo(App.map);
          };
        })(this));
        z = this.validation.zones_service.setZoneArea(z);
        if ((z != null ? z.extra_info : void 0) != null) {
          z.extra_info = JSON.parse(z.extra_info);
        }
        z.visible.on('click', (function(_this) {
          return function(e) {
            return _this.findByTarget(e);
          };
        })(this));
        this.scope.zone_object.zones.push(z);
        this.selectZone(this.scope.zone_object.zones[index]);
      }
      return this.scope.loaded.table = true;
    };

    DefineZonesController.prototype.findByTarget = function(e, delete_zone) {
      var j, len, ref, ref1, results, v, zone;
      if (delete_zone == null) {
        delete_zone = false;
      }
      v = e.target;
      ref = this.scope.zone_object.zones;
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        zone = ref[j];
        if ((zone != null ? (ref1 = zone.visible) != null ? ref1._leaflet_id : void 0 : void 0) === (v != null ? v._leaflet_id : void 0)) {
          if (delete_zone) {
            results.push(this.deleteZone(zone));
          } else {
            results.push(this.selectZone(zone, true, true));
          }
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    DefineZonesController.prototype.featureCollection = function(features) {
      return {
        type: 'FeatureCollection',
        features: [features]
      };
    };

    DefineZonesController.prototype.tryMultiPolygonize = function(geojson) {
      var ref;
      if ((geojson != null ? (ref = geojson.features) != null ? ref.length : void 0 : void 0) > 0) {
        return L.GeoUtil.multiPolygonize(geojson);
      } else {
        return L.GeoUtil.multiPolygonize(this.featureCollection(geojson));
      }
    };

    DefineZonesController.prototype.sortFeatureVsCollection = function(unknown, result) {
      if ((unknown != null ? unknown.features : void 0) != null) {
        result = result.concat(unknown.features);
      }
      if ((unknown != null ? unknown.geometry : void 0) != null) {
        result.push(unknown);
      }
      return result;
    };

    DefineZonesController.prototype.formatData = function(feature1, feature2) {
      var result;
      result = this.sortFeatureVsCollection(feature1, []);
      return {
        type: 'FeatureCollection',
        features: this.sortFeatureVsCollection(feature2, result)
      };
    };

    DefineZonesController.prototype.handleCombineDrawnZone = function(drawn, previous, collection, field) {
      var clip, combine, intersect, result, within;
      intersect = turfintersect(drawn, previous);
      clip = true;
      if (intersect) {
        if (this.ctrl.mode === 'add' || this.ctrl.mode === 'union') {
          result = merge(this.formatData(previous, drawn));
        } else {
          within = turf.pointsWithinPolygon(turf.explode(previous), this.featureCollection(drawn));
          if ((within != null ? within.features.length : void 0) === turf.explode(previous).features.length) {
            this.ctrl.layer.clearLayers();
            clip = false;
          } else {
            result = turf.difference(previous, drawn);
          }
        }
      } else {
        if (this.ctrl.mode === 'add' || this.ctrl.mode === 'union') {
          combine = this.formatData(previous, drawn);
          result = L.GeoUtil.multiPolygonize(combine);
        } else {
          within = turf.pointsWithinPolygon(turf.explode(previous), this.featureCollection(drawn));
          if ((within != null ? within.features.length : void 0) === turf.explode(previous).features.length) {
            result = turf.difference(previous, drawn);
            clip = false;
          } else {
            result = previous;
          }
        }
      }
      if (clip) {
        return this.pgis.cleanse(result).then((function(_this) {
          return function(response) {
            return _this.clipAll(response.data.data, collection, field);
          };
        })(this));
      } else {
        return this.scope.$apply();
      }
    };

    DefineZonesController.prototype.clipAll = function(combined, collection, field) {
      if ((combined != null) && (collection != null) && (field != null) && ((combined != null ? combined.type : void 0) != null)) {
        return this.pgis.clipAll(combined, collection, field).then((function(_this) {
          return function(response) {
            _this.ctrl._finishDrawing(response.data.data);
            _this.scope.fillgeom = null;
            return _this.fillGeom();
          };
        })(this));
      }
    };

    DefineZonesController.prototype.validateLayer = function(layer) {
      var ref, ref1, ref2;
      return (layer != null ? (ref = layer.features) != null ? ref.length : void 0 : void 0) > 0 || (layer != null ? (ref1 = layer.geometry) != null ? (ref2 = ref1.coordinates) != null ? ref2.length : void 0 : void 0 : void 0) > 0;
    };

    DefineZonesController.prototype.validateLayers = function(layers) {
      var j, l, len;
      for (j = 0, len = layers.length; j < len; j++) {
        l = layers[j];
        if (!this.validateLayer(l)) {
          return false;
        }
      }
      return true;
    };

    DefineZonesController.prototype.initializeListeners = function() {
      this.ctrl.on('mfdraw:undo-update', (function(_this) {
        return function(data) {
          return _this.undo.update(data.previous);
        };
      })(this));
      this.ctrl.on('mfdraw:undo', (function(_this) {
        return function() {
          return _this.undo.undo();
        };
      })(this));
      this.scope.$on('mfdraw:apply', (function(_this) {
        return function() {
          _this.fillGeom();
          _this.deleteEmptyZones();
          return _this.scope.$apply();
        };
      })(this));
      this.ctrl.on('mfdraw:poly-complete', (function(_this) {
        return function() {
          _this.undo.cleanup();
          return _this.validation.validate();
        };
      })(this));
      this.ctrl.on('mfdraw:poly-removed', (function(_this) {
        return function() {
          _this.undo.updateButtonStatus();
          _this.validation.validate();
          return _this.scope.$apply();
        };
      })(this));
      this.ctrl.addTransform((function(_this) {
        return function(type, layer, combined, previous) {
          var collection, field, j, len, ref, zone;
          layer = layer.toGeoJSON();
          previous = previous.toGeoJSON();
          collection = [];
          field = _this.tryMultiPolygonize(_this.scope.field_data.boundary);
          ref = _this.scope.zone_object.zones;
          for (j = 0, len = ref.length; j < len; j++) {
            zone = ref[j];
            if (zone !== _this.scope.current_zone) {
              collection.push(_this.tryMultiPolygonize(zone.visible.toGeoJSON()));
            }
          }
          if (_this.validateLayers([layer, previous])) {
            return _this.handleCombineDrawnZone(_this.tryMultiPolygonize(layer), _this.tryMultiPolygonize(previous), collection, field);
          } else {
            return _this.clipAll(combined, collection, field);
          }
        };
      })(this));
      this._setModeListeners(this.ctrl);
      this.scope.auto = true;
      this.ctrl.on('mfdraw:shape-added', (function(_this) {
        return function() {
          _this.scope.polygons = _this.ctrl.getAreas([], null, 1, _this.pgis.units);
          return _this.validation.validate();
        };
      })(this));
      App.map.on('click', (function(_this) {
        return function() {
          var ref, ref1, ref2, ref3;
          if ((ref = _this.ctrl) != null ? (ref1 = ref.current_tool) != null ? (ref2 = ref1.h) != null ? (ref3 = ref2._markers) != null ? ref3.length : void 0 : void 0 : void 0 : void 0) {
            _this.scope.disabled.next = true;
            _this.undo.enable();
            return _this.scope.$apply();
          }
        };
      })(this));
      this.transitionStart = this.transitions.onStart({}, (function(_this) {
        return function($transition) {
          var ref, ref1, ref2, ref3;
          if (_.startsWith($transition.to().name, 'grower.fields-define')) {
            _this.scope.died_willingly = true;
            _this.deleteEmptyZones();
            if (_this.scope.fillgeom) {
              if (turf.area((ref = _this.scope.current_zone.visible) != null ? ref.toGeoJSON() : void 0) > 0) {
                _this.addZone();
              }
              _this.ctrl._finishDrawing(_this.scope.fillgeom);
            }
            _this.resetOtherZoneColors(null, _this.validation.zones_service.defaultZoneStyle());
          }
          if (_this.ctrl) {
            if ((ref1 = _this.ctrl.current_tool) != null) {
              ref1.disable();
            }
            if ((ref2 = _this.ctrl.current_tool) != null) {
              if ((ref3 = ref2.h) != null) {
                ref3.disable();
              }
            }
          }
          return _this.undo.cleanup();
        };
      })(this));
      this.scope.$on('$destroy', (function(_this) {
        return function() {
          var base, j, len, ref, zone;
          if (!_this.scope.died_willingly) {
            _this.validation.clearLayers();
            _this.validation.settings = {};
            ref = _this.scope.zone_object.zones;
            for (j = 0, len = ref.length; j < len; j++) {
              zone = ref[j];
              if ((zone != null ? zone.visible : void 0) != null) {
                if (typeof (base = App.map).removeLayer === "function") {
                  base.removeLayer(zone.visible);
                }
              }
            }
          }
          if (_this.ctrl != null) {
            App.map.removeControl(_this.ctrl);
          }
          return _this.transitionStart();
        };
      })(this));
      return this.scope.$parent.steps.once('switch-from', "grower.fields-define." + this.zone_type + "-draw", (function(_this) {
        return function(data) {
          var j, len, ref, z;
          if (!data.is_forward) {
            ref = _this.scope.zone_object.zones;
            for (j = 0, len = ref.length; j < len; j++) {
              z = ref[j];
              z.visible.clearLayers();
            }
            _this.scope.field_data.visited_settings = null;
          }
          return _this.validation.setZones(_this.scope.zone_object.zones);
        };
      })(this));
    };

    DefineZonesController.prototype._setModeListeners = function(ctrl) {
      ctrl.addCallback('draw-poly-add', (function(_this) {
        return function() {
          return _this.scope.mode = 'Add Shape';
        };
      })(this));
      ctrl.addCallback('draw-rect-add', (function(_this) {
        return function() {
          return _this.scope.mode = 'Add Rectangle';
        };
      })(this));
      ctrl.addCallback('draw-circle-add', (function(_this) {
        return function() {
          return _this.scope.mode = 'Add Circle';
        };
      })(this));
      ctrl.addCallback('draw-poly-sub', (function(_this) {
        return function() {
          return _this.scope.mode = 'Subtract Shape';
        };
      })(this));
      ctrl.addCallback('draw-rect-sub', (function(_this) {
        return function() {
          return _this.scope.mode = 'Subtract Rectangle';
        };
      })(this));
      ctrl.addCallback('draw-circle-sub', (function(_this) {
        return function() {
          return _this.scope.mode = 'Subtract Circle';
        };
      })(this));
      return ctrl.addCallback('*', (function(_this) {
        return function() {
          return void 0;
        };
      })(this));
    };

    return DefineZonesController;

  })(Controller);

}).call(this);
